// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".treatment-detail .v-skeleton-loader__image{left:0;height:250px}@media only screen and (max-width:959.98px){.treatment-detail .v-skeleton-loader__image{height:150px}}", ""]);
// Exports
module.exports = exports;
